import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import { useNavigate } from "react-router-dom";
import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs"

import target1 from "../../assets/Images/infomonitor.png";
import target2 from "../../assets/Images/3dcat.jpg";



import Slideshow from "../../assets/Slideshow/Slideshow"; 

const Lo1Target = () => {
    const navigate = useNavigate();

    const images = [target1, target2];

    return (
        <div className="page-container">
            <Navbar />
            
            <div className="content-lo1-headings">
                <h1>Target Audience</h1>
                <p>I have to define who my product is for by identifying their demographics, personality, and needs.</p>
            </div>

            <div className="line"></div>

            <div style={{ padding: '0.1rem 7.5rem' }}>
                            <BreadcrumbHeader />
            </div>

            <div className="content-lo1">
                <div className="content-lo1-target">
                    <div className="content-lo1-target-text">
                        <h1>Who is my target audience?</h1>
                        <p>
                            Since my client is Fontys Marketing and their goal is to promote the new minor, it makes perfect sense 
                            that the primary target is students, so someone like me. As a student myself, I understand the mindset,
                            and interest of the audience we're trying to reach. This gives me a chance to make a marketing campaign
                            that is unique and authentic. 
                        </p>

                        
                        
                    </div>

                    <div className="content-lo1-target-text2">
                        <h1>Cat meme as a campaign</h1>
                        <p>
                            We chose to use cat memes as a theme for our campaign because they are easily and widely recognized,
                            humorous, and the chance to get it spread is high especially among our target audience:students.

                        </p>
                        <h2>Why is using cat memes a good strategy?</h2>
                        <p>Cat memes trigger emotional response such as amusement or joy, what we are doing is basically emotional
                            maketing. This fits perfectly with what we want to do which is to make our campaign unique and authentic.
                            since nowdays students constantly gets information throughtout their routines, seeing something funny and
                            visually attracting could make them remember important messages.
                        </p>
                        
                    </div>

                    {/* <div className="content-lo1-target-text3">
                        <h1>3D Poster and Arduino</h1>
                        <p>
                            My group leader Adib and I created this 3D poster which will make a cat noise when people/students are passing 
                            infront of our 3D poster, we do this to get people around this poster attracted and wants to go see it.
                        </p>
                    </div> */}


                    <div className="content-lo1-target-slideshow">
                        <Slideshow images={images} />

                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Lo1Target;